export { default } from '@material-ui/icons/DragHandle';
